<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" novalidate [formGroup]="formInventoryOutput">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>

            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button [title]="'Imprimir'" [severity]="'contrast'" [icon]="'pi pi-print'"
                (onClick)="printPage()"></app-custom-button>
              <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
                (onClick)="deleteInventoryOutput()"></app-custom-button>
              <!-- Opcion creada para eliminar todas las existencias del almacén, solo se debe habilitar manualmente en casos especiales -->
              <app-custom-button *ngIf="isASADMIN" [title]="'Eliminar Existencias'" [severity]="'contrast'"
                [icon]="'pi pi-history'" (onClick)="deleteAllBalances()"></app-custom-button>

              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createNewInventoryOutput()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="inventoryOutputContract.userNameCreate"
                [createDate]="inventoryOutputContract.createDate"
                [userNameUpdate]="inventoryOutputContract.userNameUpdate"
                [updateDate]="inventoryOutputContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div class="row col-lg-12">
            <div class="col-lg-7 col-md-7 col-sm-12 col-12 pe-lg-4 pe-md-2">
              <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                  <app-custom-select formControlName="inventoryId" [labelText]="'Inventario'" [list]="listInventory"
                    [required]="true" [recovery]="true" (onChangeSelect)="changeInventory($event, true)">
                  </app-custom-select>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                  <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranch"
                    [required]="true" [recovery]="true" (onChangeSelect)="changeBranch($event, true)">
                  </app-custom-select>
                </div>
                <div class="col-lg-2 col-md-4 col-sm-3 col-6">
                  <app-custom-select formControlName="inventoryOutputTypeId" [labelText]="'Tipo'"
                    [list]="listInventoryOutputType" [required]="true" [recovery]="true"
                    (onChangeSelect)="changeInventoryOutputType($event)">
                  </app-custom-select>
                </div>
                <div class="col-lg-2 col-md-3 col-sm-3 col-6">
                  <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                    [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
                </div>
                <div class="col-lg-4 col-md-9 col-sm-6 col-12">
                  <app-custom-select formControlName="conceptId" [labelText]="'Concepto'" [list]="listConcept"
                    [disabled]="!permissionUpdatable || inventoryOutputContract.inventoryOutputStateId != 1"
                    [required]="true" (onChangeSelect)="getConcept($event)"></app-custom-select>
                </div>
                <div class="col-lg-5 col-md-8 col-sm-6 col-12">
                  <app-custom-autocomplete formControlName="clientId" [labelText]="'Cliente'" [list]="listClient"
                    [required]="true" (onChangeSelect)="getClient($event)"></app-custom-autocomplete>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-3 col-6">
                  <app-custom-datepicker formControlName="dateOutput" [labelText]="'Fecha'"
                    [required]="true"></app-custom-datepicker>
                </div>
              </div>
              <div *ngIf="showRequieredOrder" class="row">
                <div class="col-lg-2 col-md-3 col-sm-3 col-6 d-flex align-items-center">
                  <app-custom-checkbox formControlName="swInternalOrder" [labelText]="'Req. Ped.Int.'"
                    (onChangeCheckBox)="changeRequieredInternalOrder()"></app-custom-checkbox>
                </div>
                <div class="col-lg-2 col-md-3 col-sm-3 col-6 ">
                  <app-custom-input-number formControlName="internalOrderConsecutive" [labelText]="'Nro.Ped.Int.'"
                    [required]="true" [recovery]="true"
                    (onChangeNumber)="changeConsecutiveInternalOrder()"></app-custom-input-number>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                  <app-custom-input-text [value]="responsible" [labelText]="'Responsable'"
                    [disabled]="true"></app-custom-input-text>
                </div>
                <div class="col-lg-2 col-md-3 col-sm-3 col-6">
                  <app-custom-input-text [value]="maintenanceOrderClassText" [labelText]="'Clase OM'"
                    [disabled]="true"></app-custom-input-text>
                </div>
                <div class="col-lg-2 col-md-3 col-sm-3 col-6">
                  <app-custom-input-text [value]="maintenanceOrderConsecutiveText" [labelText]="'Nro. OM'"
                    [disabled]="true"></app-custom-input-text>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                  <app-custom-input-text [value]="maintenanceOrderEquipmentText" [labelText]="'Equipo'"
                    [disabled]="true"></app-custom-input-text>
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-12 col-12 ps-lg-4 ps-md-2 pt-lg-0 pt-sm-2">
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-2 col-6">
                  <app-custom-tag [label]="'Estado'" [value]="stateText"
                    [severity]="inventoryOutputContract.inventoryOutputStateId === stateOpen ? 'danger' : ''">
                  </app-custom-tag>
                </div>
                <div class="col-lg-6 col-md-8 col-sm-8 col-6 d-flex align-items-end justify-content-start gap-2">
                  <app-custom-button [icon]="iconState" [title]="titleState" [severity]="'primary'"
                    (onClick)="changeState()"></app-custom-button>

                  <div class="d-flex align-items-end gap-1">
                    <app-custom-chip *ngIf="visibleDevolution" [label]="'Devolución: ' + devolutionNumber" />
                    <app-custom-chip *ngIf="visibleInvoice"
                      [label]="labelInvoice ? 'Factura: ': 'Cta.Cobro: ' + invoiceNumber" />
                    <app-custom-chip *ngIf="siesaSynchronization"
                      [label]="'Envío Siesa: ' + (inventoryOutputContract.sendDateAccounting ? (inventoryOutputContract.sendDateAccounting | date: 'dd/MM/yyyy hh:mm:ss') : '')"  />
                  </div>
                </div>
                <!-- </div>
              <div class="row"> -->
                <div class="col-lg-10 col-md-12 col-sm-12 col-12">
                  <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [rows]="1"
                    [autoResize]="false" [maxLength]="250"></app-custom-textarea>
                </div>
                <div
                  class="col-lg-2 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-end mt-sm-2  mt-2">
                  <app-custom-button [label]="'Guardar'" [severity]="'primary'" [disabled]="disabledForm"
                    [variant]="undefined" (onClick)="send()"></app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-2 container-style">
    <app-inventory-output-detail [disabledDetail]="disabledDetail" [inventoryOutputModel]="inventoryOutputContract"
      [quantityDetails]="quantityDetails" [permissionUpdatable]="permissionUpdatable"
      [swAllowsNegativeShopBalances]="swAllowsNegativeShopBalances" (hasQuantityInZero)="hasQuantityInZero = $event"
      (emitQuantityDetails)="changeQuantityDetails($event)">
    </app-inventory-output-detail>
  </div>
</section>

<!-- Impresión -->
<app-print-inventory-output id="print-inventory-output" [formatModel]="formatModel"
  [inventoryOutputPrintModel]="inventoryOutputPrintModel" [focusText]="true" [editFormat]="false"
  (finishLoadingPrint)="finishLoading($event)"></app-print-inventory-output>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{ nameWindow }} abiertas.</h6>
</div>